// @ts-strict-ignore
import { Controller } from '@hotwired/stimulus'
import { updateConsents, setConfig } from '@uswitch/rvuconsent'

export default class extends Controller<HTMLFormElement> {
  static targets = [
    'platinumEmailCapture',
    'platinumEmailCaptureForm',
    'platinumEmailCaptureFormButton',
    'platinumEmailCaptureFormInput',
    'platinumEmailCaptureText',
    'platinumEmailCaptureSuccessText',
    'platinumEmailCaptureFooter',
  ]

  declare readonly platinumEmailCaptureTarget: HTMLElement
  declare readonly platinumEmailCaptureFormTarget: HTMLElement
  declare readonly platinumEmailCaptureFormButtonTarget: HTMLElement
  declare readonly platinumEmailCaptureFormInputTarget: HTMLElement
  declare readonly platinumEmailCaptureTextTarget: HTMLElement
  declare readonly platinumEmailCaptureSuccessTextTarget: HTMLElement
  declare readonly platinumEmailCaptureFooterTarget: HTMLElement
  errorId = 'EmailCapture__formError'
  timer: any
  waitTime = 500

  async submitConsent(email: string, consentName: string, consentSource: string) {
    return await updateConsents({
      email,
      consents: [
        {
          status: true,
          name: consentName,
          source: consentSource,
          sourceUrl: window.location.href,
        },
      ],
    })
  }

  validateEmail(email: string) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      )
  }

  errorMessage(message: string) {
    const error = document.getElementById(this.errorId)
    if (!error) {
      const error = document.createElement('div')
      error.id = this.errorId
      error.classList.add(this.errorId)
      error.textContent = message
      this.platinumEmailCaptureFormInputTarget.after(error)
    }
  }

  validateForm() {
    const erroredInput = 'EmailCapture__formInputError'
    const email = this.platinumEmailCaptureFormInputTarget.value

    if (email) {
      if (!this.validateEmail(email)) {
        this.addOrRemoveError(this.errorId, erroredInput, 'add')
        this.platinumEmailCaptureFormButtonTarget?.setAttribute('disabled', 'true')
      } else {
        this.addOrRemoveError(this.errorId, erroredInput, 'remove')
        this.platinumEmailCaptureFormButtonTarget?.removeAttribute('disabled')
      }
    } else {
      this.addOrRemoveError(this.errorId, erroredInput, 'remove')
    }
  }

  addOrRemoveError(errId: string, input: string, action: string) {
    if (action === 'remove') {
      const error = document.getElementById(errId)
      error?.remove()
      this.platinumEmailCaptureFormInputTarget?.classList.remove(input)
    } else {
      this.errorMessage('Please input a valid email')
      this.platinumEmailCaptureFormInputTarget?.classList.add(input)
    }
  }

  handleKeyUp() {
    this.timer && clearTimeout(this.timer)

    this.timer = setTimeout(() => {
      this.validateForm()
    }, this.waitTime)
  }

  async submitForm() {
    const consentName = this.platinumEmailCaptureTarget.getAttribute('data-consent-name') || ''
    const consentSource = this.platinumEmailCaptureTarget.getAttribute('data-consent-source') || ''
    const email = this.platinumEmailCaptureFormInputTarget.value
    await this.submitConsent(email, consentName, consentSource)
    const form = this.platinumEmailCaptureFormTarget
    form?.classList.add('EmailCapture__formHidden')
    const text = this.platinumEmailCaptureTextTarget
    text?.classList.add('EmailCapture__text__hidden')
    const successMessage = this.platinumEmailCaptureSuccessTextTarget
    successMessage?.classList.add('EmailCapture__text__success__shown')
    const footer = this.platinumEmailCaptureFooterTarget
    footer?.classList.add('EmailCapture__footer__hidden')
  }

  connect() {
    if (this.platinumEmailCaptureTarget) {
      setConfig({
        apiPath: 'https://www.money.co.uk/consent',
        clientId: 'fs-core',
        brand: 'money',
      })
    }

    this.platinumEmailCaptureFormButtonTarget?.addEventListener('click', async () => {
      try {
        await this.submitForm()
      } catch (error) {
        this.errorMessage('An error occurred')
      }
    })
  }
}
